<script setup>
import { useForm } from "@inertiajs/inertia-vue3";
import { ref, reactive } from "vue";
import Cart from "../../../Shared/Cart";
import AddressForm from "../Partials/AddressForm";

const emit = defineEmits([
  'update:modelValue'
])

const props = defineProps({
  modelValue: Object,
  reservations: Object,
  address: Object,
})

const cart = new Cart();
const shippingAddress = ref()
const billingAddress = ref(props.address)
const separate_shipping_address = ref(false)
const form = useForm({
  reservations: [],
  pickup_terms: false,
})

function submitForm() {
  form.reservations = props.reservations;
  form.transform((data) => ({
    ...data,
    separate_shipping_address: separate_shipping_address.value,
    billingAddress: billingAddress.value,
    shippingAddress: separate_shipping_address.value ?
      shippingAddress.value :
      billingAddress.value

  })).post(route('customer-checkout'), {
    onSuccess: () => {
      cart.clearItems()
    }
  });
}

</script>

<template>
  <form @submit.prevent="submitForm()">

    <AddressForm v-model="billingAddress" :key="address"  :errors="form.errors" errors-name="billingAddress">
      <template #title>
        Uw gegevens
      </template>
    </AddressForm>

    <div class="mt-4 mb-4 flex items-center">
      <input v-model="separate_shipping_address" id="same-as-shipping" name="same-as-shipping" type="checkbox" class="h-4 w-4 border-gray-300 rounded text-primary focus:ring-primary">
      <div class="ml-2">
        <label for="same-as-shipping" class="text-sm text-gray-500">Ik bestel voor iemand anders </label>
      </div>
    </div>

    <AddressForm m v-if="separate_shipping_address" v-model="shippingAddress" :errors="form.errors" errors-name="shippingAddress">
      <template v-if="separate_shipping_address" #title>
        Gegevens van diegene waar u voor besteld
      </template>
    </AddressForm>

    <div class="mt-6 flex space-x-2">
      <div class="flex items-center h-5">
        <input v-model="form.pickup_terms" id="pickup_terms_2" name="terms" type="checkbox" class="h-4 w-4 border-gray-300 rounded text-primary focus:ring-primary" />
      </div>
      <label for="pickup_terms_2" class="text-sm text-gray-500">Ik begrijp dat de bestelling eerst goedgekeurd moet worden voordat ik de bestelling op kan halen. Zie uw bevestigingsmail voor meer informatie.</label>
    </div>

    <div v-if="form.errors.pickup_terms" v-text="form.errors.pickup_terms" class="text-red-500 text-xs mt-1"></div>

    <button type="submit" :disabled="form.processing" class="w-full flex justify-center mt-4 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:opacity-80 focus:outline-none">
      <svg v-if="form.processing" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span v-text="form.processing ? 'Bezig...' : 'Bestellen'"></span>
    </button>

  </form>
</template>
